import {
    AccountRetrievalRequest,
    RestDataResponseNonPIIAccountResponse,
    nonPiiPost,
} from '@cecm-microservices-sdk/core/services/account/non-pii';
import { getMicroservicesClient } from '@/services/microservices/client';
import type { MicroservicesCountryCode } from './usedCarEligibility';

export async function fetchAccountSummary(
    countryCode: MicroservicesCountryCode,
    payload: AccountRetrievalRequest,
): Promise<RestDataResponseNonPIIAccountResponse> {
    const client = getMicroservicesClient(countryCode);

    if (!client.baseUrl) {
        throw new Error(
            `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
        );
    }

    return nonPiiPost(client, payload);
}
